// Combined Loop bundle functionality: button reordering, class addition, DOM moving, and custom header injection
// Keep track of whether tasks are complete
let buttonsReordered = false;
let classAdded = false;
let frequencyMoved = false;
let customHeaderInjected = false;
let selectArrowsAdded = false;


// Function to add custom arrows to select elements
function addCustomSelectArrows() {
  if (selectArrowsAdded) return true;
  
  const selectElements = document.querySelectorAll('select.loop-select-variant');
  if (selectElements.length > 0) {
    selectElements.forEach((select, index) => {
      // Check if arrow container already exists
      if (select.parentNode.classList.contains('select-wrapper-with-arrow')) {
        return; // Skip if already processed
      }
      
      // Create wrapper div
      const wrapper = document.createElement('div');
      wrapper.className = 'select-wrapper-with-arrow';
      wrapper.style.cssText = `
        position: relative !important;
        display: inline-block !important;
        width: 100% !important;
      `;
      
      // Create arrow element
      const arrow = document.createElement('div');
      arrow.className = 'select-arrow-icon';
      arrow.innerHTML = `
        <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="icon" style="display: block;">
          <path d="M20 8.5 12.5 16 5 8.5" stroke="currentColor" stroke-width="2.5" fill="none"/>
        </svg>
      `;
      arrow.style.cssText = `
        position: absolute !important;
        right: 12px !important;
        top: 40% !important;
        transform: translateY(-50%) !important;
        pointer-events: none !important;
        color: #666666 !important;
        z-index: 2 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 14px !important;
        height: 14px !important;
        line-height: 1 !important;
      `;
      
      // Wrap the select element
      select.parentNode.insertBefore(wrapper, select);
      wrapper.appendChild(select);
      wrapper.appendChild(arrow);
      
      // Add hover and focus event listeners to change arrow color
      select.addEventListener('mouseenter', () => {
        arrow.style.color = '#08C5BC !important';
      });
      
      select.addEventListener('mouseleave', () => {
        arrow.style.color = '#666666 !important';
      });
      
      select.addEventListener('focus', () => {
        arrow.style.color = '#08C5BC !important';
      });
      
      select.addEventListener('blur', () => {
        arrow.style.color = '#666666 !important';
      });
    });
    
    selectArrowsAdded = true;
    
    return true;
  } else {
    
    return false;
  }
}

// Targeted function specifically for #loop-background
function addClassToLoopBackground() {
  const loopBackground = document.getElementById('loop-background');
  if (loopBackground) {
    if (!loopBackground.classList.contains('loop-bundles-bcm')) {
      loopBackground.classList.add('loop-bundles-bcm');
      
      
      classAdded = true;
      return true;
    } else {
      
      classAdded = true;
      return true;
    }
  } else {
    
    return false;
  }
}

// Enhanced class injection function
function injectLoopBundlesClass() {
  if (classAdded) return true;
    
  // First try the specific #loop-background element
  if (addClassToLoopBackground()) {
    return true;
  }
  
  // Fallback to other selectors if #loop-background not found
  const possibleSelectors = [
    '.loop-container',
    '.loop-bs-container',
    '.loop-widget',
    '.loop-app',
    '[id*="loop"]',
    '[class*="loop"]',
    '[data-loop]',
    '[id^="loop"]',
    '[class^="loop"]',
    'div[class*="Loop"]',
    'div[id*="Loop"]'
  ];
  
  let loopElement = null;
  let usedSelector = '';
  
  for (const selector of possibleSelectors) {
    try {
      const elements = document.querySelectorAll(selector);
      if (elements.length > 0) {
        // Prefer elements that look like main containers
        loopElement = Array.from(elements).find(el => {
          const id = el.id || '';
          const className = String(el.className || '');
          return id.includes('background') || 
                 id.includes('container') || 
                 className.includes('container') ||
                 className.includes('background') ||
                 el.children.length > 0; // has child elements
        }) || elements[0]; // fallback to first element
        
        if (loopElement) {
          usedSelector = selector;
          break;
        }
      }
    } catch (e) {
      console.warn(`Selector "${selector}" failed:`, e);
    }
  }
  
  if (loopElement && !loopElement.classList.contains('loop-bundles-bcm')) {
    loopElement.classList.add('loop-bundles-bcm');
    classAdded = true;
    return true;
  } else if (loopElement && loopElement.classList.contains('loop-bundles-bcm')) {
    classAdded = true;
    return true;
  } else {
    console.warn('❌ No suitable Loop container element found');
    return false;
  }
}

function injectCustomHeader() {
  // BUGFIX (Apr 2026): the previous container list ended in
  //   document.querySelector('body')
  // as a fallback. On cart / product / customers/* pages — where
  // loop-frequency-mover.js loads but the Loop bundle widget isn't
  // mounted — the loop-* selectors all returned null and the
  // body fallback fired, injecting the
  //   "Bundle & Save / Get up to 30% / (+ save more when you subscribe)"
  // promo header at the very top of every page. Reported by user.
  //
  // Restrict to selectors that ONLY match when the actual Loop
  // bundle subscription widget is present in the DOM. The
  // [id*="loop"] wildcard is also dropped because it matches
  // unrelated 'loop-' prefixed apps + theme classes.
  const possibleContainers = [
    document.getElementById('loop-background'),
    document.querySelector('.loop-bundles-bcm'),
    document.querySelector('.loop-container.loop-bs-container')
  ].filter(Boolean);

  if (possibleContainers.length > 0) {
    const container = possibleContainers[0];
    
    // Check if custom header doesn't already exist
    const existingHeader = document.querySelector('.bcm-custom-header');
    if (!existingHeader) {
      // Create the custom header HTML
      const customHeader = document.createElement('div');
      customHeader.className = 'bcm-custom-header';
      
      // COPY (Aug 2026): the tiered box discount is a SUBSCRIPTION offer — it is earned by
      // putting the box on a delivery schedule, not by the item count alone (same rule the
      // spark builder enforces in assets/spark-bundle-builder.js). "Get up to 30% when you
      // buy 4 items / (+ save more when you subscribe)" promised the tier to a one-time
      // buyer and framed subscribing as an extra; both are now wrong.
      customHeader.innerHTML = `
        <div class="bcm-custom-header-content">
          <h1 class="bcm-custom-header-title">Bundle & Save</h1>
          <p class="bcm-custom-header-subtitle">Get up to 30% when you subscribe to 4 items</p>
          <p class="bcm-custom-header-sub-subtitle">(change, skip, or cancel anytime)</p>
        </div>
      `;
      
      // Insert at the beginning of the container
      container.insertAdjacentElement('afterbegin', customHeader);
      customHeaderInjected = true;
      
      
      return true;
    } else {
      customHeaderInjected = true;
      return true;
    }
  } else {
    return false;
  }
}

// Immediate execution with enhanced debugging
setTimeout(() => {
  

  addClassToLoopBackground(); // Direct attempt
  injectLoopBundlesClass();
  injectCustomHeader();
  addCustomSelectArrows(); // Add select arrows
}, 100);

const observer = new MutationObserver(() => {
  // Handle custom header injection if not already done
  if (!customHeaderInjected) {
    injectCustomHeader();
  }

  // Handle class injection if not already done - try direct method first
  if (!classAdded) {
    if (!addClassToLoopBackground()) {
      injectLoopBundlesClass();
    }
  }

  // Handle select arrows if not already done
  if (!selectArrowsAdded) {
    addCustomSelectArrows();
  }

  // Handle button reordering if not already done
  if (!buttonsReordered) {
    const container = document.querySelector('.loop-frequency-selector');
    if (container) {
      const buttons = Array.from(container.querySelectorAll('button'));
      
      const everyMonthBtn = buttons.find(btn => btn.textContent.trim() === "Every Month");
      const every2WeeksBtn = buttons.find(btn => btn.textContent.trim() === "Every 2 Weeks");
      const oneTimeBtn = buttons.find(btn => btn.textContent.trim() === "One Time Delivery");

      if (everyMonthBtn && every2WeeksBtn && oneTimeBtn) {
        // Clear and reorder
        container.innerHTML = '';
        container.appendChild(everyMonthBtn);
        container.appendChild(every2WeeksBtn);
        container.appendChild(oneTimeBtn);
        
        buttonsReordered = true;
      }
    }
  }
  
  // Handle frequency selector moving if not already done
  if (!frequencyMoved) {
    const frequencySelector = document.querySelector('.loop-frequency-size-selector');
    const footerDescriptionWrapper = document.querySelector('.footer-description-wrapper');
    
    if (frequencySelector && footerDescriptionWrapper) {
      // Move the frequency selector before the footer-description-wrapper
      const parentDiv = footerDescriptionWrapper.parentNode;
      parentDiv.insertBefore(frequencySelector, footerDescriptionWrapper);
      frequencyMoved = true;
    }
  }
  
  // Disconnect observer if all tasks are complete
  if (buttonsReordered && classAdded && frequencyMoved && customHeaderInjected && selectArrowsAdded) {
    observer.disconnect();
  }
});

// Start observing the body for changes
observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['id', 'class']
});

// Also check once when the DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  

  
  // Check for custom header injection on DOM load
  if (!customHeaderInjected) {
    injectCustomHeader();
  }
  
  // Try class injection on DOM load - direct method first
  if (!classAdded) {
    if (!addClassToLoopBackground()) {
      injectLoopBundlesClass();
    }
  }

  // Try select arrows on DOM load
  if (!selectArrowsAdded) {
    addCustomSelectArrows();
  }
  
  // Check for frequency selector moving on DOM load
  const frequencySelector = document.querySelector('.loop-frequency-size-selector');
  const footerDescriptionWrapper = document.querySelector('.footer-description-wrapper');
  
  if (frequencySelector && footerDescriptionWrapper && !frequencyMoved) {
    const parentDiv = footerDescriptionWrapper.parentNode;
    parentDiv.insertBefore(frequencySelector, footerDescriptionWrapper);
    frequencyMoved = true;
  }
  
  // If all tasks are complete, disconnect the observer
  if (buttonsReordered && classAdded && frequencyMoved && customHeaderInjected && selectArrowsAdded) {
    observer.disconnect();
  }
});

// More aggressive backup checks with direct targeting
setTimeout(() => {
  
  if (!classAdded) {
    addClassToLoopBackground() || injectLoopBundlesClass();
  }
  if (!customHeaderInjected) {
    injectCustomHeader();
  }
  if (!selectArrowsAdded) {
    addCustomSelectArrows();
  }
}, 1000);

setTimeout(() => {
  

  if (!classAdded) {
    addClassToLoopBackground() || injectLoopBundlesClass();
  }
  if (!customHeaderInjected) {
    injectCustomHeader();
  }
  if (!selectArrowsAdded) {
    addCustomSelectArrows();
  }
}, 3000);

setTimeout(() => {
  

  
  if (!classAdded) {
    console.warn('⚠️ FINAL WARNING: loop-bundles-bcm class was never successfully added');
    addClassToLoopBackground() || injectLoopBundlesClass();
  } else {
    
  }
  
  if (!customHeaderInjected) {
    console.warn('⚠️ FINAL WARNING: Custom header was never successfully injected');
    injectCustomHeader();
  } else {
    
  }

  if (!selectArrowsAdded) {
    console.warn('⚠️ FINAL WARNING: Select arrows were never successfully added');
    addCustomSelectArrows();
  } else {
    
  }
}, 5000); 